import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DesignatedUnitsTableCardTableService } from '../designated-units-table-card-table.service';

@Component({
  selector: 'app-designated-units-table-header',
  templateUrl: './designated-units-table-header.component.html',
  styleUrls: ['./designated-units-table-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DesignatedUnitsTableCardTableHeaderComponent {
  private tableService = inject(DesignatedUnitsTableCardTableService);

  public readonly activeSort$ = this.tableService.activeSort$;
  public updateActiveSort = (sortString: string): void => this.tableService.updateActiveSort(sortString);
}
